//  valid positions: op-left top-right bottom-left bottom-right top bottom left right center

export const notifyConfiguration = {

    progress: true,
    position: 'top-right',
    timeout: 500
}
